import htmlToDom from '../../../../helpers/htmlToDom';
import makeAddressWorkerElement from './makeAddressWorkerElement';

export default ({ address, coords, metroColor, workers }) =>
	htmlToDom(`
			<li 
				class="modal__address-item"
				data-rm-address="${address.replace(/"/g, '\&quot;')}"
				data-rm-address-coords="${JSON.stringify(coords)}"
			>
				<button class="modal__address-wrapper">
					${address}
					<svg class="modal__svg" loading="lazy" style="fill: ${metroColor}">
						<use xlink:href="./images/sprite.svg#metro"></use>
					</svg>
				</button>
				<ul class="modal__address-workers">
					${workers
						.map(makeAddressWorkerElement)
						.map((el) => el.outerHTML)
						.join('')}
				</ul>
			</li>
		`);
